
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageLoadingState } from "@/components/ui/page-loading-state";

const RequireAuth = () => {
  const { user, isLoading, sharedAccess } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoadingState message="Loading..." />;
  }
  
  // Require authentication or shared access
  if (!user && !sharedAccess) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
